import { instance } from "./apiClient";

export const expensesListsApi = {
  getExpensesLists: (showArchived = false) =>
    instance
      .get(`/api/expenses_lists?with_archived=${showArchived}`)
      .then((res) => res.data),

  getExpensesList: ({ listId, month }) =>
    instance
      .get(`/api/expenses_lists/${listId}?month=${month}`)
      .then((res) => res.data),

  createExpensesList: (payload) =>
    instance.post("/api/expenses_lists", payload).then((res) => res.data),

  updateExpensesList: ({ listId, payload }) =>
    instance
      .put(`/api/expenses_lists/${listId}`, payload)
      .then((res) => res.data),

  deleteExpensesList: (listId) =>
    instance.delete(`/api/expenses_lists/${listId}`).then((res) => res.data),

  archiveExpensesList: (listId) =>
    instance
      .put(`/api/expenses_lists/${listId}/archive`)
      .then((res) => res.data),

  unarchiveExpensesList: (listId) =>
    instance
      .put(`/api/expenses_lists/${listId}/unarchive`)
      .then((res) => res.data),
};
